import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolClientAction } from '../symbolClient.action';

type IDependencies = IClientApiDependencySegment;

export const bulkRemoveSymbolClientEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolClientAction.bulkRemove.started),
  mergeMap((params) => {
    return dependencies.api.bulkDeleteClientSymbols(params).pipe(
      mergeMap(() => [SymbolClientAction.bulkRemove.done({ params })]),
      catchApiError((error) => [
        SymbolClientAction.bulkRemove.failed({ params, error }),
        createApiErrorNotification(error),
      ]),
    );
  }),
);
